import React from "react";
import { useBillingHistory } from "@hooks/useBillingHistory";
import { Loader } from "@design-system/Loader/Loader";
import { Section } from "@design-system/Section/Section";
import { BillingHistoryCard } from "./BillingHistoryCard";

export const BillingHistory: React.FC = () => {
    const { data: billingHistory, isFetched } = useBillingHistory();

    if (!isFetched) {
        return <Loader />;
    }

    if (!billingHistory?.invoices?.length) {
        return null;
    }

    return (
        <Section heading="Billing history">
            <BillingHistoryCard billingHistory={billingHistory} />
        </Section>
    );
};
